import { BodyLG } from "../../../typography/body/BodyLG";
import { HeadingXL } from "../../../typography/heading/HeadingXL";
import { config } from "../config/patientRightsConfig";

export const Body = () => {
  return (
    <>
      {config.map((item) => (
        <div className="tw-flex tw-flex-col tw-gap-y-[1em]">
          <HeadingXL className="tw-my-0 tw-text-blue-dark-3">
            {item.section}
          </HeadingXL>
          {item.list && (
            <ol className="tw-my-0 tw-pl-[1.5em]">
              {item.list.map((listItem) => (
                <li className="tw-my-0">
                  <BodyLG className="tw-my-0 tw-text-gray-2">{listItem}</BodyLG>
                </li>
              ))}
            </ol>
          )}
          {item.description &&
            item.description.map((paragraph) => (
              <BodyLG className="tw-my-0 tw-text-gray-2">{paragraph}</BodyLG>
            ))}
        </div>
      ))}
    </>
  );
};
